import {useContext,useState,useEffect,memo} from 'react'
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import  Button  from '@mui/material/Button';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

import { LanguageContext } from '../../context';
import  '../../config.json'
import { getAll } from '../../Data/Utils';
import { buildItemsList,getItemVal  } from '../../Data/GeneralFanction';
import Translate from '../Translate/Translate'
import { Link ,redirect,useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom';
import { useQueryParam, NumberParam, StringParam } from 'use-query-params';
import './Filter.css'
import { MobileView } from 'react-device-detect';

const Filter = ({categories}) => {

  // const [categoriesState,setCategoriesState]=useState([]);
  const [categoriesSelected,setCategoriesSelected]= useState([]);
  const [typeViewSelected,setTypeViewSelected]=useState([]);
  const [tabsData,setTabsData]=useState([]);   

  const {language }=useContext(LanguageContext);

  const [categoryF, setCategoryF] = useQueryParam('categoryF', StringParam);
  const [typeF, setTypeF] = useQueryParam('typeF', StringParam);

 


  const navigate = useNavigate();


  useEffect(()=>{
   
    var config = require('../../config.json');    
    setTabsData(config.DataItemTabs);
    if(categoryF!=undefined && categoryF!=''){
      setCategoriesSelected(categoryF.split(','));
    }
    else{
      setCategoriesSelected([])
    }
    if(typeF!=undefined && typeF!=''){
      setTypeViewSelected(typeF.split(','));
    }
    else{
      setTypeViewSelected([])
    }
    //getCtegories();
    
  })

  // useEffect(()=>{
  //   if(typeF!=undefined && typeF!=''){
  //   setTypeViewSelected(typeF.split(','));
  //   }
  //   else{
  //     setTypeViewSelected([])
  //   }
  // },[typeF])

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setCategoriesSelected(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );

    navigate(`/${language}?categoryF=${event.target.value.toString()}&typeF=${typeViewSelected.toString()}`);
  };

  const handleChangeType = (event) => {
    const {target: { value },} = event;
    setTypeViewSelected(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  
    navigate(`/${language}?categoryF=${categoriesSelected.toString()}&typeF=${event.target.value.toString()}`);
  };

  const clearHandle=(event)=>{
    setCategoriesSelected([]);
    setTypeViewSelected([]);
    navigate(`/${language}`);
    return false;

  }

  const renderSelectedValueType=(selected)=>{
    var showItems='';
    for(var i=0;i<selected.length;i++){
      // var x= tabsData.find((f)=>f.label.en==selected[i]);
      // if(x!=undefined)
      showItems=showItems+tabsData.find((f)=>f.label.en==selected[i]).label[language]+", ";
    }
    if(showItems.indexOf(',')>-1)
      showItems=showItems.substring(0,showItems.lastIndexOf(','));
    return showItems;
  }


  const renderSelectedValueCategories=(selected)=>{
    if(selected==undefined)
      return "";
    var showItems='';
    var field=language=="he"?"Title":"Title_"+language;
    if(!Array.isArray(selected)){
      selected=selected.split(',');
    }
   //if(selected.indexOf(',')>-1){
      //selected=selected.split(',');
    //}
    for(var i=0;i<selected.length;i++){
      if(selected[i]!='')
        showItems=showItems+categories.find((c)=>c.ID.Value==selected[i])[field].Value+", ";
    }
    if(showItems.indexOf(',')>-1)
      showItems=showItems.substring(0,showItems.lastIndexOf(','));
    return showItems;
  }

  // const getSelectedValueCategories=(categoryF)=>{
  //   var showItems='';
  //   if(categoryF.indexOf(',')==-1){
  //     var field=language=="he"?"Title":"Title_"+language;
  //   }
   
  //   for(var i=0;i<selected.length;i++){
  //     showItems=showItems+categories.find((c)=>c.ID.Value==selected[i])[field].Value+", ";
  //   }
  //   if(showItems.indexOf(',')>-1)
  //     showItems=showItems.substring(0,showItems.lastIndexOf(','));
  //   return showItems;
  // }
  
  
    
  return (
    <div className='filter-container'>
      <h2 className='offset'>{renderSelectedValueCategories(categoryF)}</h2>
      <div className='info'><Translate>FilterInfo</Translate></div>
 <FormControl sx={{ m: 1, width: 300 }}>
        <InputLabel id="demo-multiple-name-label-category"><Translate>Category</Translate></InputLabel>
        <Select
          labelId="demo-multiple-name-label-category"sss
          id="demo-multiple-name-category"
          multiple
          value={categoriesSelected}
          onChange={handleChange}
          input={<OutlinedInput label="Category" renderValue={(selected) => selected.join(', ')}/>}
          renderValue={(selected) => renderSelectedValueCategories(selected)}
       
        >
          {categories.map((category) => (
            <MenuItem
              key={category.ID.Value}
             
              value={category.ID.Value }
            >
        
        <Checkbox checked={categoriesSelected.indexOf(category.ID.Value) > -1} />
              <ListItemText primary={getItemVal(language=='he'?"Title":"Title_"+language,category)} />
              
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl sx={{ m: 1, width: 300 }}>
        <InputLabel id="demo-multiple-name-label-type"><Translate>TypeSearch</Translate></InputLabel>
        <Select
          labelId="demo-multiple-name-label-type"
          id="demo-multiple-name-type"
          multiple
          value={typeViewSelected}
          onChange={handleChangeType}
          input={<OutlinedInput label="TypeSearch" />}
          renderValue={(selected) => renderSelectedValueType(selected)}
       
        >
          {tabsData.map((tab,index) => (
            tab.label.en.toLocaleLowerCase()!='info' &&
            <MenuItem
              key={index}
             
              value={tab.label.en }
            >      
             
              <Checkbox checked={typeViewSelected.indexOf(tab.label.en ) > -1} />
              <ListItemText primary= {tab.label[language]} />
              
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* <Link to={{pathname:`/`}}> */}
        <Button variant="contained" size="large" onClick={clearHandle} className="clear" ><Translate>Clear</Translate></Button>
        {/* </Link> */}
        <MobileView>
          <a href="#" onClick={clearHandle} className="mobile-clear"><Translate>Clear</Translate></a>
        </MobileView>
    </div>
  )
}

export default memo(Filter)